import {
  LOADING,
  TABLE_ROWS_LOADED,
  MODAL_INTERACTION,
  FAILED,
} from '../actions/constants';
import { SHARE_HTML } from '../util/enums/EnumModals';

const INITIAL_STATE = {
  pin: '', // start empty
  wrongPin: false,
  title: null, // title of view
  updatedAt: null, // when data was loaded
  rowCount: null, // total rowCount
};

const ShareHtml = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== SHARE_HTML) {
        return state;
      }
      return { ...state, pin: action.payload.props.pin };
    }
    case TABLE_ROWS_LOADED: {
      return {
        ...state,
        title: action.payload._title,
        updatedAt: action.payload._cached_time,
        rowCount: action.payload._rowLimit,
      };
    }
    case LOADING:
      if (action.awaiting === TABLE_ROWS_LOADED) {
        return { ...INITIAL_STATE }; // reset
      }
      return state;
    case FAILED:
      if (action.awaiting === TABLE_ROWS_LOADED) {
        return { ...state, wrongPin: true };
      }
      return state;
    default:
      return state;
  }
};

export default ShareHtml;
